import { applyMiddleware, createStore, compose } from 'redux';
import thunk from 'redux-thunk';
import { syncHistoryWithStore } from 'react-router-redux';
import { browserHistory } from 'react-router';

import isProduction from 'app/common/lib/isProduction';

import { emit } from './actions/websockets';
import reducer from './reducers';


function configureStore() {
  const thunkMiddleware = thunk.withExtraArgument({ emit });
  if (isProduction()) return createStore(reducer, applyMiddleware(thunk));

  /* eslint-disable no-underscore-dangle */
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  return createStore(reducer, composeEnhancers(
    applyMiddleware(thunkMiddleware)
  ));
  /* eslint-enable */
}

const store = configureStore();
export const history = syncHistoryWithStore(browserHistory, store);
export default store;
